(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/utils/use-scratch-default-events.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/utils/use-scratch-default-events.js');
"use strict";


const {
  useEffect,
  useState
} = React;
const falcon = svs.ticketgames.falconBridge.falcon;
const useScratchDefaultEventsLeiaFactory = _ref => {
  let {
    demo = false,
    ticketInfo,
    isFullScreenGame,
    gameIsCompleted = false,
    onPlayAgain,
    hasUnscratchedTicket = false,
    hasNextVoucher = false,
    onClose
  } = _ref;
  const {
    autoCorrect,
    confirmClose
  } = svs.ticketgames.ticketUtility.utils.customTexts;
  const {
    resultDialogNormal,
    resultDialogDemo
  } = svs.ticketgames.ticketUtility.utils.resultDialog;
  const [gameResult, setGameResult] = useState(null);
  const [shouldShowPlayAgainFooter, setShouldShowPlayAgainFooter] = useState(false);
  const [shouldShowBubbleWinMessage, setShouldShowBubbleWinMessage] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const {
    soundStatus,
    notifySoundStatus
  } = svs.ticketgames.ticketUtility.utils.useLeiaSoundStatus({
    ticketInfo
  });
  const handleGameLoaded = () => {
    setIsLoading(false);
  };
  const logCorrectionMethod = result => {
    var _result$data;
    const {
      type
    } = ticketInfo;
    if (result !== null && result !== void 0 && (_result$data = result.data) !== null && _result$data !== void 0 && (_result$data = _result$data.revelationData) !== null && _result$data !== void 0 && _result$data.hasOwnProperty('autoCorrected')) {
      const autoCorrected = result.data.revelationData.autoCorrected;
      svs.ticketgames.ticketUtility.logger.info("CorrectionMethod (".concat(type, "): ").concat(autoCorrected ? 'AUTO' : 'MANUAL'));
    }
  };
  const showWinDialog = result => {
    if (demo) {
      resultDialogDemo({
        wonAmount: result.wonAmount,
        onClose,
        onPlayAgain
      });
    } else {
      const isTicketOpen = ticketInfo.open;
      resultDialogNormal({
        wonAmount: result.wonAmount,
        onClose,
        onPlayAgain,
        hasNextVoucher,
        hasUnscratchedTicket,
        isTicketOpen
      });
    }
  };
  const handleGameComplete = _ref2 => {
    let {
      detail: result
    } = _ref2;
    if (!demo && !gameIsCompleted) {
      var _svs$ticketgames$tick;
      (_svs$ticketgames$tick = svs.ticketgames.ticketUtility.utils.tracking.gameSpecificTracking[ticketInfo.type]) === null || _svs$ticketgames$tick === void 0 || _svs$ticketgames$tick.corrected();
      svs.ticketgames.ticketUtility.utils.tracking.ticketCompleted(ticketInfo.name);
      logCorrectionMethod(result);
    }
    const gameResult = svs.ticketgames.ticketUtility.utils.normalizeWin(result);
    setGameResult(gameResult);
    if (gameResult && (!isFullScreenGame || gameIsCompleted)) {
      setShouldShowPlayAgainFooter(true);
    }
    setTimeout(() => {
      setShouldShowBubbleWinMessage(true);
    }, 500);
    if (gameResult.winFlag && !demo) {
      setTimeout(() => {
        switch (ticketInfo.type) {
          case 'svstriss30campaign49y24w37':
            svs.ticketUtility.utils.starConfetti();
            break;
          default:
            svs.tur.confettiCannon();
            break;
        }
      }, 1000);
    }
    if (isFullScreenGame && !gameIsCompleted) {
      showWinDialog(result);
    }
    svs.components.account_balance && svs.components.account_balance.get(true);
  };
  const onAutoCorrect = () => {
    const {
      type
    } = ticketInfo;
    const {
      title,
      message,
      cancelTitle,
      actionTitle
    } = autoCorrect(type);
    const dialog = new svs.components.dialog.Confirm({
      branding: svs.components.dialog.branding.TUR,
      icon: 'help-2',
      title,
      message,
      actions: [{
        title: cancelTitle,
        callback: () => {
          falcon.instance.notifierProxy.sendNotification('autoCorrect', false);
          dialog.close();
        }
      }, {
        title: actionTitle,
        callback: () => {
          falcon.instance.notifierProxy.sendNotification('autoCorrect', true);
          dialog.close();
        }
      }]
    });
    svs.components.dialog.api.add(dialog);
  };
  const onOpenDoor = _ref3 => {
    let {
      detail: data
    } = _ref3;
    if (!demo) {
      var _svs$ticketgames$tick2;
      (_svs$ticketgames$tick2 = svs.ticketgames.ticketUtility.utils.tracking.gameSpecificTracking[ticketInfo.type]) === null || _svs$ticketgames$tick2 === void 0 || _svs$ticketgames$tick2.openDoor(data);
    }
  };
  const onCloseGame = event => {
    var _event$detail;
    const type = (_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : _event$detail.type;
    if (type === 'CONFIRM') {
      const {
        title,
        message,
        cancelTitle,
        actionTitle
      } = confirmClose(ticketInfo.type, demo);
      const dialog = new svs.components.dialog.Confirm({
        branding: svs.components.dialog.branding.TUR,
        icon: 'help-2',
        title,
        message,
        actions: [{
          title: cancelTitle,
          callback: () => {
            dialog.close();
          }
        }, {
          title: actionTitle,
          callback: () => {
            onClose();
            dialog.close();
          }
        }]
      });
      svs.components.dialog.api.add(dialog);
    } else {
      onClose();
    }
  };
  const handleHasBet = _ref4 => {
    let {
      detail
    } = _ref4;
    if (!demo) {
      const {
        receiptId
      } = detail;
      history.replaceState(null, '', receiptId + window.location.search);
    }
  };
  useEffect(() => {
    const scratchDefaultEventsLeia = [{
      eventName: 'HAS_BET',
      handler: handleHasBet
    }, {
      eventName: 'GAME_LOADING',
      handler: handleGameLoaded
    }, {
      eventName: 'HAS_CLAIMED',
      handler: handleGameComplete
    }, {
      eventName: 'REPLAY_FINISHED',
      handler: handleGameComplete
    }, {
      eventName: 'SHOULD_AUTO_CORRECT',
      handler: onAutoCorrect
    }, {
      eventName: 'OPEN_DOOR',
      handler: onOpenDoor
    }, {
      eventName: 'CLOSE_GAME',
      handler: onCloseGame
    }];
    scratchDefaultEventsLeia.forEach(evt => addEventListener(evt.eventName, evt.handler));
    return () => {
      scratchDefaultEventsLeia.forEach(evt => removeEventListener(evt.eventName, evt.handler));
    };
  }, []);
  return {
    isLoading,
    gameResult,
    shouldShowPlayAgainFooter,
    shouldShowBubbleWinMessage,
    soundStatus,
    notifySoundStatus
  };
};
setGlobal('svs.ticketgames.ticketUtility.utils.useScratchDefaultEventsLeiaFactory', useScratchDefaultEventsLeiaFactory);

 })(window);